import subjectCardEn from "./locales/en.json";

export const SUBJECT_CARD_NS = "subjectCard" as const;

export const SubjectCardTranslations = {
  en: {
    [SUBJECT_CARD_NS]: {
      ...subjectCardEn,
    },
  },
};
